export default __webpack_public_path__ + "static/icon-9-2-e993cdad5e3bed5bb4fecffdaf557f33.png";